import MasterLayout from 'components/layouts/MasterLayout'
import { LoadingBarProcess } from 'components/loadingProcess/LoadingBarProcess'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
const ForgotPasswordPage = React.lazy(() => import("pages/forgotPassword/ForgotPasswordPage"));

const ForgotPasswordRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={
                <React.Suspense fallback={<LoadingBarProcess />}>
                    <ForgotPasswordPage />
                </React.Suspense>
            }>
            </Route>
        </Routes>
    )
}

export default ForgotPasswordRoutes